import { api, hrRoutes } from "../../../";
import { ApiConfig } from "../../../ApiConfig";
const baseURL = ApiConfig.baseApi;
// ----------------------------------------------------------------
// Define employees services
// ----------------------------------------------------------------

const services = {
  // ----------------------------------------------------------------
  // Update a employee information
  // ----------------------------------------------------------------

  update: async (
    data,
    imgUrl,
    user,
    docsUrl,
    mobile,
    cCode,
    emergency,
    emergencyCode,
    workplace,
    workplaceCode,
    nationalities
  ) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + hrRoutes.employee.update + user?._id;
    const params = {
      isActive: data?.isActive?.value || false,
      // empId: data?.empNumber?.value || user?.empId,
      personalInfo: {
        firstName: data?.firstName?.value || user?.personalInfo?.firstName,
        surName: data?.lastName?.value || user?.personalInfo?.surName,
        nickName: data?.nickName?.value || user?.personalInfo?.lastName,
        gender: data?.gender?.value || user?.personalInfo?.gender,
        mobile: mobile || user?.personalInfo?.mobile,
        cCode: cCode || user?.personalInfo?.cCode,
        jobPosition: data?.jobPosition?.value
          ? [data?.jobPosition?.value]
          : user?.personalInfo?.jobPosition,
        department: data?.department?.value || user?.personalInfo?.department,
        operator: data?.operator?.value || user?.personalInfo?.operator,
        addressLine1: data?.address1?.value || user?.personalInfo?.addressLine1,
        addressLine2: data?.address2?.value || user?.personalInfo?.addressLine2,
        city: data?.city?.value || user?.personalInfo?.city,
        zipCode: data?.zipCode?.value || user?.personalInfo?.zipCode,
        country: data?.country?.value || user?.personalInfo?.country,
        email: data?.email?.value || user?.personalInfo?.email,
        dob: data?.dob?.value || user?.personalInfo?.dob,
        education: data?.education?.value || user?.personalInfo?.education,
        image: imgUrl ? imgUrl : user?.personalInfo?.image,

        password: data?.password?.value?.trim() || "",
        password_confirmation:
          data?.confirmPassword?.value?.trim() || "",
      },
      otherInformation: {
        nationality: nationalities || user?.otherInformation?.nationality,
        religion: data?.religion?.value,
        martial: data?.marital?.value,
        passportNo:
          data?.passportNum?.value || user?.otherInformation?.passportNo,
        emergencyContact:
          emergency || user?.otherInformation?.emergencyContact || 0,
        workplace: workplace || user?.otherInformation?.workplace || "",
        emergencyCCode: emergencyCode || user?.otherInformation?.emergencyCCode,
        workplaceCCode: workplaceCode || user?.otherInformation?.workplaceCCode,
      },
      salaryInfo: {
        salary: Number(data?.salary?.value),
        hRate: data?.hourlyRate?.value,
        restraintTrade: data?.restraintTrade?.value,
        travelAll: data?.travelAll?.value,
        payfreq: data?.payfreq?.value,
        paymentType: data?.paymentType?.value,
        rateRembTravel: data?.rateRembTravel?.value || 0,
      },
      bankInfo: {
        bank: data?.bankName?.value || user?.bankInfo?.bank,
        account: data?.accountNum?.value || user?.bankInfo?.account,
        bankCode: data?.ifscCode?.value || user?.bankInfo?.ifsc,
        accountHolder:
          data?.accountHolder?.value || user?.bankInfo?.accountHolder,
        taxCode: data?.personalTaxCode?.value || user?.bankInfo?.vat,
        acType: data?.accountType?.value || user?.bankInfo?.acType,
        issuedDate: data?.issuedDate?.value || user?.bankInfo?.issuedDate,
      },
      experience: {
        joiningDate: data?.joiningDate?.value || user?.experience?.joiningDate,
        exp: data?.experience?.value || user?.experience?.exp,
      },
      additionalInformation: {
        isprofile: data?.profileVisibility?.value || false,
        istasknoti: data?.taskNoti?.value || false,
        isTracked: data?.isTracked?.value || false,

        isPreAttendance: data?.isPreAttendance?.value || false,

        empType: data?.empType?.value || user?.additionalInformation?.empType,
        isOverTime: data?.isOverTime?.value || false,
        overTimeRate:
          data?.rate?.value || user?.additionalInformation?.overTimeRate,
        isExtraTime: data?.isExtraTime?.value || false,
        extraTimeRate:
          data?.extraTimeRate?.value ||
          user?.additionalInformation?.extraTimeRate,
        isDoubleOverTime: data?.isDoubleOverTime?.value || false,
        doubleOverTimeRate:
          data?.doubleOverTimeRate?.value ||
          user?.additionalInformation?.doubleOverTimeRate,
      },

      socialMedia: {
        skype: data?.urlSkype?.value,
        instagram: data?.urlLinkedin?.value,
        linkedIn: data?.urlInsta?.value,
        facebook: data?.urlFb?.value,
      },
      taxInfo: {
        idNumber: data?.idNumber?.value,
        taxRefNo: data?.taxRefNo?.value,
        medicalAidNo: data?.medicalAidNo?.value,
      },
      projects: Array.isArray(data?.projects?.value)
        ? data.projects.value
          .map((proj) => (typeof proj === "string" ? proj : proj?.name))
          .filter(Boolean)
        : [],
      docs: docsUrl,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api.put(url, params, headers);
  },

  // ----------------------------------------------------------------
  // Search employees list
  // ----------------------------------------------------------------

  search: async (text, page = 1, sort, section) => {
    const token = localStorage.getItem("accessToken");
    const id = localStorage.getItem("id");
    const params = new URLSearchParams();

    if (text) params.append("search", text);
    if (page) params.append("page", page);
    if (sort) params.append("sort", sort);
    if (section) params.append("section", section);

    const url = `${baseURL}${hrRoutes.employee.list}${id}${params.toString() ? `/?${params.toString()}` : ""
      }`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.get(url, params, headers);
  },

};

// Export the services
export default services;
